import React from "react";
import contentfulStandardApp, { fetchProps } from "@insightfulscience/contentful/Apps/Standard";
import { useLocale } from "@insightfulscience/i18";
import PageMeta from "@insightfulscience/smart-react/PageMeta";
import SiteLayout from "../../SiteLayout";
import SectionTryForFree from "../../SectionTryForFree";
import BlockLinks from "../../contentful/Apps/components/BlockLinks";
import Page from "../../contentful/Apps/Standard/Page";
import resources from "../../../locales";
import AcademyHero from "../../contentful/Apps/components/AcademyHero";
import BlockFeaturedContent from "../../contentful/Apps/components/BlockFeaturedContent/BlockFeaturedContent";
import { REVALIDATE_TIME, contentfulProps } from "../../config";

const academyPageLayout = ({ children }) => {
	const [t] = useLocale("standard-pages");
	return (
		<SiteLayout>
			<PageMeta>
				<PageMeta.Twitter image={t("META_TWITTER_IMAGE")} isImageBaseUrl />
			</PageMeta>
			{children}
			<SectionTryForFree />
		</SiteLayout>
	);
};

const ContentfulAcademyApp = contentfulStandardApp({
	Layout: academyPageLayout,
	Page,
	contentfulProps,
	pageProps: {
		resources,
		brandCode: "gn",
		siteDomain: "https://www.geneious.com",
		components: {
			linksBlock: BlockLinks,
			heroBlock: AcademyHero,
			blockFeaturedContent: BlockFeaturedContent,
		},
	},
	mode: "isr",
});

export const getStaticProps = async () => {
	const props = await fetchProps(contentfulProps, "academy");

	return {
		props,
		revalidate: REVALIDATE_TIME,
	};
};

export default ContentfulAcademyApp;
